<template>
	<div ref="dataEdit" class="full-container">
		<div class="full-top-wrap">
			Subject Detail
		</div>
		<div class="full-center-wrap">
			<form @submit.prevent="doValidation()">
				<p class="txt-crud-title">
					Subject Form
				</p>
				<table class="tb-crud-horizon">
					<colgroup>
						<col width="11%" />
						<col width="39%" />
						<col width="11%" />
						<col width="39%" />
					</colgroup>
					<tbody>
						<tr>
							<th>Subject</th>
							<td colspan="3">
								<input
									type="text"
									class="input-crud"
									name="screeningName"
									v-model="items.screeningName"
									readonly
									style="width: 43%;"
								/>
							</td>
						</tr>
						<tr>
							<th>
								Subject No.
							</th>
							<td>
								<input
									type="text"
									class="input-crud"
									:class="(errors.has('subjectNo') || isDuplicate ? 'input-crud-error' : '')"
									name="subjectNo"
									v-model="items.subjectNo"
									data-vv-as="Screening"
									:placeholder="(errors.has('subjectNo') ? 'The Subject No. is required' : 'please enter the Subject No.')"
								/>
							</td>
							<th>
								Initial
							</th>
							<td>
								<input
									type="text"
									class="input-crud"
									:class="(errors.has('initial') || isDuplicate ? 'input-crud-error' : '')"
									name="initial"
									v-model="items.initial"
									data-vv-as="Screening"
									:placeholder="(errors.has('initial') ? 'The Initial is required' : 'please enter the Initial')"
								/>
							</td>
						</tr>
						<tr>
							<th>
								Site
							</th>
							<td>
								<select
									class="select-crud"
									:class="(errors.has('siteCode') ? 'input-crud-error' : '')"
									name="siteCode"
									v-model="items.siteCode"
									v-validate="'required'"
									data-vv-as="Site"
									style="width: 100%;"
									disabled
								>
									<option value="" selected disabled>--- select ---</option>
									<option v-for="(item, index) in siteList" :key="index" :value="item.siteCode">
										{{ item.siteName }}
									</option>
								</select>
							</td>
							<th>
								Consent Date
							</th>
							<td>
								<label 
									class="label-date-picker"
									:style="utils.isEmpty(items.informedConsentDt)? 'color: #ccc' : 'color: #999'"
								>
									{{
										(
											getDateValue()
										) 
									}} 
									<i class="mx-icon">
										<i class="mx-icon-calendar">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1em" height="1em">
												<path d="M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z">
												</path>
											</svg>
										</i>
										<i class="mx-icon-clear"
											@click="clearDate()"
										>
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1em" height="1em">
												<path d="M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z">
												</path>
											</svg>
										</i>
									</i>
									<date-picker
										ref="date-picker"
										v-model="items.informedConsentDtTemp"
										value-type="format"
										format="YYYY-MM-DD"
										:lang="lang"
										style="width: 0px; height: 0px; overflow: hidden;"
										v-validate="'required'"
										name="informedConsentDt"
										data-vv-as="Consent Date"
										confirm
										@change="doValidCheck(items)"
									/>
								</label>
								<p class="txt-validation" v-if="errors.has('informedConsentDt')">
										* {{ errors.first("informedConsentDt") }}
								</p>
							</td>
						</tr>
						<tr>
							<th>
								Register
							</th>
							<td>
								{{ items.firstRegistUserId }}
							</td>
							<th>
								Modify Date
							</th>
							<td>
								{{ items.lastModifyDate }}
							</td>
						</tr>
						<tr>
							<th>
								Note
							</th>
							<td colspan="3">
								<textarea
									class="textarea-crud"
									name="screeningNote"
									v-model="items.screeningNote"
								>
								</textarea>
							</td>
						</tr>
					</tbody>
				</table>
			</form>
		</div>
		<div class="full-bottom-wrap">
			<button v-if="workAccessCheck('EDIT') && !(projectStateCd == '4')" type="button" class="btn-save fright" title="Save" @click.stop="doValidation()">
				Edit
			</button>
			<button type="button" class="btn-cancel fright" title="Cancel" @click.stop="doCancel()" style="margin-right: 10px;">
				Cancel
			</button>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import EventBus from "@/script/EventBus.js";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';


export default {
	name: "ScreeningEdit",
	beforeCreate(){
		let item = {
			userId: sessionStorage.getItem("userId"),
			privilegeTypeCd: "2",
			privilegeCategory: "TEST ENTRY",
			privilegeName: "EDIT",
			projectNo: this.$route.params.projectNo
		}
		this.$accessAuth(item).then((status) => {
			if(status == false){
				this.$router.go(-1);
				this.$alert("You are not authorized.","Warning","warning");
			}
		})
	},
	created() {
		this.logger.debug(this, "created()");
		this.selectSiteList();
		this.select();
		this.getAccessList('TEST ENTRY');
		this.getProjectStateCd();
	},
	components: {
		DatePicker
	},
	data() {
		return {
			items: {},
			siteList: [],
			lang: {
				formatLocale: {
					monthsShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
					weekdays: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
					weekdaysMin: ['일', '월', '화', '수', '목', '금', '토']
				},
				yearFormat: 'YYYY년',
				monthBeforeYear: false,
			},
			accessList: [],
			projectStateCd: ""
		};
	},
	watch: {},
	methods: {
		selectSiteList() {
			this.logger.debug(this, "selectSiteList()");
			axios
				.post(this.config.contextRoot + "/site/selectList.do", {})
				.then((response) => {
					console.log(response);
					this.siteList = response.data.siteList;
					this.$nextTick(function () {
						setTimeout(function() {
							EventBus.$emit("project-loading", false);
						}.bind(this), 500);
					});
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		select() {
			this.logger.debug(this, "select()");
			axios
				.post(this.config.contextRoot + "/testScreening/select.do", {testScreeningNo: this.$route.params.testScreeningNo})
				.then((response) => {
					console.log(response);
					this.items = response.data.item;
					this.items.projectNo = this.$route.params.projectNo;
					this.items.lastModifyDate = moment().format("YYYY-MM-DD");
					this.items.informedConsentDtTemp = this.items.informedConsentDt;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doValidCheck(item){
			var date = item.informedConsentDtTemp;
			let newDate = new Date().toISOString().slice(0, 10);
			console.log(newDate);
			var splitdate = date.split("-");
			var splittoday = newDate.split("-");
			if(splitdate[0] > splittoday[0]){
				item.informedConsentDtTemp = "";
				item.informedConsentDt = "";
				this.$alert("Invalid date.","Warning","warning");
			}
			if(splitdate[0] == splittoday[0] && splitdate[1] > splittoday[1]){
				item.informedConsentDtTemp = "";
				item.informedConsentDt = "";
				this.$alert("Invalid date.","Warning","warning");
			}
			if(splitdate[0] == splittoday[0] && splitdate[1] == splittoday[1] && splitdate[2] > splittoday[2]){
				item.informedConsentDtTemp = "";
				item.informedConsentDt = "";
				this.$alert("Invalid date.","Warning","warning");
			}
		},
		leftPad(value) {
			if (value >= 10) {
				return value;
			}
			return '0' + value;
		},
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result)
					{
						this.$confirm("Do you want to modify the current data?","Question","question").then(() => {
							EventBus.$emit("project-loading", true);
							this.doUpdate();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		doUpdate() {
			this.logger.debug(this, "doUpdate()");
			let informedConsentDt = this.items.informedConsentDt;
			if(typeof informedConsentDt === 'object' && informedConsentDt instanceof Date)
			{
				this.$set(this.items, "informedConsentDt", this.items.informedConsentDt);
			}
			axios
				.post(this.config.contextRoot + "/testScreening/update.do", this.items)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						var url = this.config.contextRoot + "/project/" + this.$route.params.projectNo + "/testScreening";
						if (this.$route.path !== url)
						{
							this.$router.push(url);
						}
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("Do you want to cancel the data modification?","Question","question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.dataEdit.style.animation = "fadeOutUp 0.4s ease-in-out both";
			setTimeout(function() {
				let url = this.config.contextRoot + "/project/" + this.items.projectNo + "/testScreening"
				if (this.$route.path !== url)
				{
					EventBus.$emit("project-loading", true);
					this.$router.push(url);
				}
			}.bind(this), 410);
		},
		getDateValue() {
			var informedConsentDtTemp = this.items.informedConsentDtTemp;
			var informedConsentDt = this.items.informedConsentDt;

			if(this.utils.isEmpty(informedConsentDtTemp))
			{
				if(this.utils.isEmpty(informedConsentDt))
				{
					return "YYYY-MM-DD"
				}
				else
				{
					return informedConsentDt;
				}
			}
			else
			{
				{
					this.$set(this.items, "informedConsentDt", informedConsentDtTemp);
				}
				return this.items.informedConsentDt;
			}
		},
		clearDate() {
			this.$set(this.items, "informedConsentDt", "");
			this.$set(this.items, "informedConsentDtTemp", "");
			setTimeout(function() {
				let popup = document.getElementsByClassName("mx-datepicker-popup")[0];
				popup.style.display = "none";
			}.bind(this), 0);
		},
		getAccessList(category){
			axios
				.post(this.config.contextRoot + "/access/getCategoryPrivilegeList.do", {privilegeCategory: category})
				.then((response) => {
					console.log(response);
					this.accessList = response.data.privilegeList;
					this.accessList.forEach((obj) =>{
						this.workCheck(obj);
					})
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		async workCheck(obj){
			let item = {};
			item = {
				userId: sessionStorage.getItem("userId"),
				projectNo: this.$route.params.projectNo,
				privilegeTypeCd: obj.privilegeTypeCd,
				privilegeCategory: obj.privilegeCategory,
				privilegeName: obj.privilegeName
			}
			obj.isAccess = await this.$accessAuth(item);
		},
		workAccessCheck(name){
			for(let  i = 0; i < this.accessList.length; i++){
				if(this.accessList[i].privilegeName == name){
					return this.accessList[i].isAccess;
				}
			}
		}
	}
};
</script>
<style scoped>
.label-date-picker {
	display: flex;
    align-items: center;
}
</style>